import { ScopeModel as s } from "./scope.model.js";
class u {
  adapt(a) {
    var i, t, r, n;
    const o = (l) => ({
      name: l.name,
      id: l.id
    });
    return new s(
      a.areas ?? [],
      a.locations ?? [],
      a.location_groups ?? [],
      a.organizations ?? [],
      a.additional_data ? {
        location: ((i = a.additional_data.location) == null ? void 0 : i.map(o)) ?? [],
        locationGroup: ((t = a.additional_data.location_group) == null ? void 0 : t.map(o)) ?? [],
        organization: ((r = a.additional_data.organization) == null ? void 0 : r.map(o)) ?? [],
        area: ((n = a.additional_data.area) == null ? void 0 : n.map(o)) ?? []
      } : void 0
    );
  }
  serialize(a) {
    return {
      areas: (a == null ? void 0 : a.areas) ?? [],
      locations: (a == null ? void 0 : a.locations) ?? [],
      location_groups: (a == null ? void 0 : a.locationGroups) ?? [],
      organizations: (a == null ? void 0 : a.organizations) ?? []
    };
  }
  toQueryString(a) {
    const o = new URLSearchParams(), {
      areas: i = [],
      locations: t = [],
      locationGroups: r = [],
      organizations: n = []
    } = a ?? {};
    return i.length > 0 && o.set("scope_areas", i.join(",")), t.length > 0 && o.set("scope_locations", t.join(",")), r.length > 0 && o.set("scope_location_groups", r.join(",")), n.length > 0 && o.set("scope_organizations", n.join(",")), o;
  }
  toCookieName(a) {
    const o = a.areas.join(","), i = a.locations.join(","), t = a.locationGroups.join(","), r = a.organizations.join(","), n = a.additionalData ? JSON.stringify(a.additionalData) : "", l = `areas:${o}|locations:${i}|locationGroups:${t}|organizations:${r}`;
    return n ? `${l}|additional:${n}` : l;
  }
}
export {
  u as ScopeAdapter
};
//# sourceMappingURL=scope.adapter.js.map
